import { render, staticRenderFns } from "./EmdCopy.vue?vue&type=template&id=8399d878&"
import script from "./EmdCopy.vue?vue&type=script&lang=js&"
export * from "./EmdCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdCopy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8399d878')) {
      api.createRecord('8399d878', component.options)
    } else {
      api.reload('8399d878', component.options)
    }
    module.hot.accept("./EmdCopy.vue?vue&type=template&id=8399d878&", function () {
      api.rerender('8399d878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/molecules/EmdCopy.vue"
export default component.exports